import { useEffect, useRef } from 'react';

export function useTimeout(callback: () => void, delay: number | null) {
    const callbackRef = useRef(callback);
    // Store callback in ref so that the useEffect isn't triggered (resetting the timeout) when it changes
    useEffect(() => {
        callbackRef.current = callback;
    });

    useEffect(() => {
        if (delay == null) {
            return;
        }

        const handle = setTimeout(() => {
            callbackRef.current();
        }, delay);

        // Clear previous timeout, if still pending
        return () => {
            clearTimeout(handle);
        };
    }, [delay]);
}
